import { defineStore } from "pinia";
import Services from '@/services/sutting/admissionChannelsServices';
import { mapList, mapAdmissionChannel } from '@/helpers/mapFuncs'


export const useAdmissionChannelsStore = defineStore("admissionChannels", {
  persist: true,
  state: () => ({
    admissionChannel: {},
    admissionChannels: [],
  }),
  getters: {
    getAdmissionChannel() {
      return mapAdmissionChannel(this.admissionChannel);
    },
    getAdmissionChannels() {
      return this.admissionChannels.map(mapAdmissionChannel);
    },
    getAdmissionChannelsList() {
      return this.admissionChannels.map(mapList);
    },
  },
  actions: {
    /** Start Sets */
    setAdmissionChannel(admissionChannel) {
      this.admissionChannel = admissionChannel;
    },
    setAdmissionChannels(admissionChannels) {
      this.admissionChannels = admissionChannels;
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
      return Services.get(id).then((response) => {
        this.setAdmissionChannel(response.data.data);
        return response;
      });
    },
    getAll(data) {
      return Services.getAll(data).then((response) => {
        this.setAdmissionChannels(response.data.data??[]);
        return response;
      });
    },
    add(data) {
      return Services.add(data).then((response) => {
        this.admissionChannels.push(response.data.data);
        return response;
      });
    },
    edit(id, data) {
      return Services.edit(id, data).then((response) => {
        this.admissionChannels[this.admissionChannels.findIndex((x) => x.id == id)] = response.data.data;
        return response;
      });
    },
    delete(id) {
      return Services.delete(id).then((response) => {
        this.admissionChannels = this.admissionChannels.filter((x) => x.id != id);
        return response;
      });
    },
    /** End Actions */
  },
});
